import React, { useEffect, useMemo, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  Grid,
  Button,
  Select,
  Divider,
  TextField,
  InputLabel,
  Typography,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  FormHelperText,
  Chip,
  MenuItem,
  Tooltip,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import dayjs from "dayjs";
import { CheckBoxOutlineBlank, CheckBox } from "@material-ui/icons";
import { DropzoneArea } from "material-ui-dropzone";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";
import ROUTER from "../../../constants/router";

import MultiFileManager from "../../File/MultiFileManager/MultiFileManager";

import { uploadFile, uploadMultiFile } from "../../../reducer/file/action";
import { updateOtherWork, acceptOtherWork, requestRevisionOtherWork } from "../../../reducer/otherWork/action";
import { ModalWorkflowActions } from "../../../components/WorkflowStatus";
import { statisticUnaccepted } from "../../../reducer/profile/action";
import {
  getEmploymentContractById,
  getAllEmploymentContractByProfileId,
} from "../../../reducer/employmentContract/action";
import {
  getTimeResearchInformation,
  getTimeResearchInformationById,
} from "../../../reducer/timeResearchInformation/action";

import EmploymentContractTable from "../../../components/EmployContractModal/EmploymentContractTable";
import EmploymentContractDetailTable from "../../../components/EmployContractModal/EmploymentContractDetailTable";
import { KPTextfield } from "components/KPTComponents";
import { set } from "immutable";
import KPTimePicker from "components/KPTimePicker";
import moment from "moment";

function OtherWorkUpdateModal(props) {
  const { updating, setUpdating } = props;
  const [disabled, setDisabled] = useState(false);
  const dispatch = useDispatch();

  const [values, setValues] = useState(null);
  const [profileList, setProfileList] = useState([]);
  const [detail, setDetail] = useState(null);
  const [timeResearchYear, setTimeResearchYear] = useState(0);
  const [timeResearchDetailList, setTimeResearchDetailList] = useState([]);
  const [helperText, setHelperText] = useState(false);
  const [fileUrls, setFileUrls] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const profileDetail = useSelector((state) => select(state, "profileReducer", "detail"));

  const dateFormat = (value) => {
    const dateForm = value?.replaceAll("/", "");
    const date = dateForm?.substr(0, 2);
    const month = dateForm?.substr(2, 2);
    const year = dateForm?.substr(-4);
    return value ? dayjs(`${month}/${date}/${year}`).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;
  };

  useEffect(() => {
    if (updating) {
      resetValues();
      // Parse existing file URLs
      if (updating.fileUrl) {
        const urls = updating.fileUrl.split("||").filter((url) => url.trim() !== "");
        setFileUrls(urls);
      } else {
        setFileUrls([]);
      }
      setNewFiles([]);
    }
  }, [updating]);

  useEffect(() => {
    if (values?.profileIdForKpi >= 0) props.getTimeResearchInformation(0, timeResearchYear);
  }, [values?.profileIdForKpi, timeResearchYear]);

  useEffect(() => {
    const timeResearchDetailId = parseInt(values?.timeResearchDetailCode?.split("-").slice(0, 1).shift());
    if (timeResearchDetailId) props.getTimeResearchInformationById(timeResearchDetailId);
  }, [values?.timeResearchDetailCode]);

  // useEffect(() => {
  //   if (values?.profileIdForKpi) props.getAllEmploymentContractByProfileId(values?.profileIdForKpi);
  // }, [values?.profileIdForKpi]);

  // console.log(props);

  // useEffect(() => {
  //   if (props.employmentContractDetail)
  //     setValues({
  //       ...values,
  //       profileIdForKpi: props.employmentContractDetail?.profile?.id,
  //     });
  // }, [props.employmentContractDetail]);

  useEffect(() => {
    // setDetail(props?.employmentContractListById?.find((e) => e?.contract?.id === updating?.contractIdForKpi)?.contract);
    const contract = props?.employmentContractListById?.find(
      (e) => e?.contract?.id === updating?.contractIdForKpi,
    )?.contract;
    setDetail(contract?.listKpi?.find((e) => e.id === updating.kpiIdForKpi));
  }, [props?.employmentContractListById, updating?.contractIdForKpi]);

  useEffect(() => {
    if (values?.timeResearchDetailCode) {
      const selectedYear = props.timeResearchInformationList?.find(
        (info) => !!info.timeResearchDetail.find((detail) => detail.code === values?.timeResearchDetailCode),
      )?.year;

      setTimeResearchYear(selectedYear);
    }
  }, [values?.timeResearchDetailCode]);

  const resetValues = () => {
    // console.log("resetValues", updating);
    setValues({
      ...updating,
      workingTime: dayjs(updating.workingTime).format("DD-MM-YYYY")?.replaceAll("-", "/"),
      listMember: updating.listMember?.join(", "),
    });
    setProfileList([...updating.otherWorkProfile] || []);
    // if (!props.isFetchingEmploymentContract) props.getEmploymentContractById(updating.contractIdForKpi);
    // setDetail(props.employmentContractListById?.find((e) => e.contract.id === updating.contractIdForKpi)?.contract);
    const contract = props?.employmentContractListById?.find(
      (e) => e?.contract?.id === updating?.contractIdForKpi,
    )?.contract;
    setDetail(contract?.listKpi?.find((e) => e.id === updating.kpiIdForKpi));

    const timeResearchYearId = parseInt(updating.timeResearchDetailCode?.split("-")[0]);
    const year = props.timeResearchInformationList?.find((e) => e.id === timeResearchYearId)?.year || 2022;
    setTimeResearchYear(year);
  };

  const handleChangeForm = (name, value) => {
    if (name === "timeResearchDetailCode") {
      setValues({
        ...values,
        [name]: value === "null" ? null : value,
      });
    } else setValues({ ...values, [name]: value });
  };

  const handleChangeProfileList = (index, name, value) => {
    const temp = profileList;
    const tempElm = profileList[index];
    temp.splice(index, 1, { ...tempElm, [name]: value });
    setProfileList([...temp]);
  };

  const handleInsert = () => {
    const temp = profileList;
    temp.push({
      profileId: null,
      roleInOtherWork: "member",
      statusInProject: "K",
      isInternal: true,
      externalName: "",
    });
    setProfileList([...temp]);
  };

  const handleRemove = (index) => {
    if (profileList[index].profileId === values?.profileIdForKpi) handleChangeForm("profileIdForKpi", null);
    const temp = profileList;
    temp.splice(index, 1);
    setProfileList([...temp]);
  };

  const handleClose = () => {
    resetValues();
    setUpdating(null);
    setDisabled(false);
    setFileUrls([]);
    setNewFiles([]);
  };

  const handleSubmit = async () => {
    // check title, numOfMember, type
    // [VinUni] bỏ bắt buộc chọn loại công trình (không còn tính giờ)
    if (!values?.title || !values.workingTime) {
      setHelperText(true);
      return;
    }

    let uploadedUrls = "";

    if (newFiles.length > 0) {
      const res = await dispatch(uploadMultiFile(profileDetail?.id, newFiles, "otherWork"));
      if (res.success) {
        const newUrls = res.data || [];
        uploadedUrls = [...fileUrls, ...newUrls].join("||");
      }
    } else {
      uploadedUrls = fileUrls.join("||");
    }

    const tempListMember = values?.listMember?.split(",").map((author) => author.trimStart());
    const payload = {
      ...values,
      listMember: tempListMember,
      dashboardYear: values?.year,
      otherWorkProfile: profileList,
      workingTime: dateFormat(values?.workingTime || moment().format("YYYY-MM-DD")),
      fileUrl: uploadedUrls,
    };

    const result = await props.updateOtherWork(values.id, payload);
    if (result) {
      handleClose();
    }

    setDisabled(false);
  };

  const getNoteByType = () => {
    let note = "";
    if (values?.type === "consulting_with_contract") {
      note = `Hợp đồng, thanh lý hợp đồng`;
    }
    return note || _note;
  };

  // console.log(files);

  const contractList = [];
  props?.employmentContractListById.forEach((e) => contractList.push(e.contract));

  // var timeResearchDetailList =
  //   props.timeResearchInformationList?.find((e) => e.year === timeResearchYear)?.timeResearchDetail || [];

  // timeResearchDetailList = timeResearchDetailList.filter((e) => !e.allowedUpdateNum && e.type === "otherWork");
  // console.log(timeResearchDetailList)

  // Filter timeResearchDetailList without year filtering
  useEffect(() => {
    if (props.timeResearchInformationList?.length > 0) {
      // Get all timeResearchDetail from all years and filter by type
      let allDetails = [];
      props.timeResearchInformationList.forEach((yearData) => {
        if (yearData.timeResearchDetail) {
          allDetails = [...allDetails, ...yearData.timeResearchDetail];
        }
      });

      let list = allDetails.filter((e) => !e.allowedUpdateNum && e.type === "otherWork");
      setTimeResearchDetailList(list || []);

      setValues({
        ...values,
        timeResearchDetailCode: null,
      });
    }
  }, [props.timeResearchInformationList]);

  const yearList = [];
  props.timeResearchInformationList
    .sort((a, b) => b.year - a.year)
    .forEach((e) => {
      yearList.push(e.year);
    });

  const renderLockButton = () => {
    if (!values?.locked) return null;
    return (
      <Chip
        variant="outlined"
        label={`Đã khóa tính ${
          (values?.locked === "kpi" && "KPI") ||
          (values?.locked === "reward" && "thưởng") ||
          (values?.locked === "timeResearch" && "giờ nghiên cứu")
        }`}
        color="primary"
        style={{ fontSize: 15, float: "right", marginRight: 16 }}
      />
    );
  };

  const handleSendFeedback = () => {
    props.history.push({
      pathname: ROUTER.NOTIFICATION,
      state: {
        sendTo: "personal",
        title: "Thông báo về sai sót thông tin trong CTKH",
        chosenProfiles: profileList.reduce((accumulator, currentValue) => {
          accumulator.push(currentValue.profileId);
          return accumulator;
        }, []),
        data: updating,
        dataType: "otherWork",
      },
    });
  };

  const _note = useMemo(() => {
    let note = "";
    if (values?.type === "consulting_with_contract") {
      note = `Hợp đồng, thanh lý hợp đồng`;
    }
    return note;
  }, [values?.type]);

  // console.log(values);

  return (
    <Dialog
      fullWidth
      keepMounted
      maxWidth="md"
      open={updating !== null}
      onClose={handleClose}
      disableBackdropClick
      PaperProps={{
        style: {
          width: "calc(100vw - 240px)",
          height: "100vh",
          maxWidth: "calc(100vw - 240px)",
          maxHeight: "100vh",
          margin: "0 0 0 240px",
        },
      }}
    >
      <DialogTitle
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px 24px",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        {/* <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center" }}> */}
        <Typography variant="h5" style={{ marginRight: 16 }}>
          Cập nhật các hoạt động khác
        </Typography>
        <div style={{ display: "flex", gap: "12px", marginTop: 8 }}>
          {renderLockButton()}
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleClose}
            style={{ marginRight: 8, padding: "8px 24px", fontSize: "15px" }}
          >
            Hủy
          </Button>
          <Tooltip
            disableHoverListener={props.role === "sudo-admin"}
            title="Liên hệ phòng KHCN để đề xuất chỉnh sửa CTKH"
          >
            <span>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                // [VinUni] bỏ bắt buộc chọn loại công trình (không còn tính giờ)
                disabled={
                  (values?.purposeId === 1 && !(values?.profileIdForKpi && values?.contractIdForKpi)) ||
                  (values?.purposeId === 99999999 && !values?.profileIdForReward) ||
                  values?.locked ||
                  (values?.accepted && props.role !== "sudo-admin")
                }
                style={{ padding: "8px 24px", fontSize: "15px" }}
              >
                Lưu thay đổi
              </Button>
            </span>
          </Tooltip>
          <ModalWorkflowActions
            row={props.updating}
            role={props.role}
            onAccept={async () => {
              const ok = await props.acceptOtherWork(props.updating.id, !props.updating.accepted);
              if (ok) {
                props.statisticUnaccepted({ departmentId: 0, profileId: props.profile?.id });
                if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
              }
              return ok;
            }}
            onRequestRevision={(reason) => props.requestRevisionOtherWork(props.updating.id, reason)}
            onAfterAction={() => props.setUpdating(null)}
          />
          {/* </div> */}
          <div>
            {props.adminTab && (
              <Button variant="outlined" onClick={handleSendFeedback} style={{ padding: "8px 24px", fontSize: "15px" }}>
                Gửi feedback
              </Button>
            )}
          </div>
        </div>
        {/* </div> */}
      </DialogTitle>
      <DialogContent style={{ display: "flex", padding: 0, height: "calc(100vh - 64px)", overflow: "hidden" }}>
        <div style={{ width: "60%", padding: "16px 24px", overflowY: "auto", borderRight: "1px solid #e0e0e0" }}>
          <Grid container justifyContent="flex-start" spacing={2} style={{ marginBottom: 10 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Tên công trình"
                variant="outlined"
                disabled={disabled}
                value={values?.title?.toString() || ""}
                required
                error={helperText && !values?.title}
                helperText={helperText && !values?.title ? "Vui lòng nhập tên sách/ tiêu đề" : ""}
                onChange={(event) => handleChangeForm("title", event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                select
                fullWidth
                size="small"
                disabled={disabled}
                label="Loại công trình"
                variant="outlined"
                value={values?.timeResearchDetailCode || null}
                onChange={(event) => handleChangeForm("timeResearchDetailCode", event.target.value)}
                InputLabelProps={{
                  shrink: !(values?.timeResearchDetailCode === undefined || values?.timeResearchDetailCode === null),
                }}
                // [VinUni] bỏ bắt buộc chọn loại công trình (không còn tính giờ)
                error={false}
              >
                {timeResearchDetailList.length > 0 ? (
                  timeResearchDetailList?.map((e) => (
                    <MenuItem key={e.code} value={e.code}>
                      {e.description}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value={null} disabled>
                    Chưa có dữ liệu
                  </MenuItem>
                )}
              </TextField>
            </Grid>
            {/* <Grid item xs={12}>
              <FormControl fullWidth variant="outlined" size="small" error={helperText && !values?.type}>
                <InputLabel style={{ padding: "0 8px", backgroundColor: "white" }}>Loại công trình</InputLabel>
                <Select
                  native
                  fullWidth
                  disabled={disabled}
                  value={values?.type || ""}
                  onChange={(event) => handleChangeForm("type", event.target.value)}
                >
                  <option value="consulting_with_contract">Tư vấn doanh nghiệp (có Hợp đồng qua Trường)</option>
                </Select>
                {helperText && !values?.type && <FormHelperText>Không được bỏ trống</FormHelperText>}
              </FormControl>
            </Grid> */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="Mã quản lý"
                disabled={disabled}
                value={values?.code || ""}
                // error={helperText && !values?.code}
                // helperText={helperText && !values?.code ? "Vui lòng nhập tên hội nghị/ hội thảo" : ""}
                onChange={(event) => handleChangeForm("code", event.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <KPTimePicker
                fullWidth
                label="Thời gian thực hiện"
                required
                value={values?.workingTime || "dd/mm/yyyy"}
                disabled={disabled}
                // error={helperText && !values?.workingTime}
                // helperText={helperText && !values?.workingTime ? "Vui lòng nhập thời gian thực hiện" : ""}
                setValue={(newValue) => handleChangeForm("workingTime", newValue)}
              />
              {helperText && !values?.workingTime && (
                <FormHelperText error>Vui lòng điền thời gian thực hiện!</FormHelperText>
              )}
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel id="purpose-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                  Mục đích
                </InputLabel>
                <Select
                  native
                  fullWidth
                  labelId="purpose-label"
                  value={values?.purposeId ?? "none"}
                  disabled={disabled}
                  onChange={(event) => handleChangeForm("purposeId", parseInt(event.target.value))}
                >
                  {props.purposes.map((e) => (
                    <option key={e.id} value={e.id}>
                      {e.description}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {/* {values?.purposeId === 5 && (
              <>
                <Grid item xs={3}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    value={timeResearchYear}
                    disabled={disabled}
                    SelectProps={{ native: true }}
                    label="Năm học tính giờ nghiên cứu"
                    variant="outlined"
                    onChange={(event) => setTimeResearchYear(parseInt(event.target.value))}
                  >
                    {yearList.map((e) => (
                      <option key={`${e} - ${e + 1}`} value={parseInt(e)}>
                        {e} - {e + 1}
                      </option>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    disabled={disabled}
                    label="Nhiệm vụ tính giờ nghiên cứu"
                    variant="outlined"
                    value={values?.timeResearchDetailCode || null}
                    onChange={(event) => handleChangeForm("timeResearchDetailCode", event.target.value)}
                    InputLabelProps={{
                      shrink: !(
                        values?.timeResearchDetailCode === undefined || values?.timeResearchDetailCode === null
                      ),
                    }}
                    // [VinUni] bỏ bắt buộc chọn loại công trình (không còn tính giờ)
                    error={false}
                  >
                    {timeResearchDetailList?.map((e) => (
                      <MenuItem key={e.code} value={e.code}>{e.description}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </>
            )} */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Tóm tắt"
                variant="outlined"
                disabled={disabled}
                value={values?.abstract || ""}
                multiline
                rows={3}
                onChange={(event) => handleChangeForm("abstract", event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                disabled={disabled}
                label="Ghi chú"
                variant="outlined"
                value={values?.note || ""}
                multiline
                rows={3}
                onChange={(event) => handleChangeForm("note", event.target.value)}
              />
            </Grid>
            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>
            <Grid item xs={2}>
              <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Thành viên</Typography>
            </Grid>
            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>
            <Grid item xs={12}>
              {profileList.map((e, index) => (
                <Grid key={`list-${index}`} container spacing={2}>
                  <Grid item xs={1}>
                    {/* Check box default is checked với text "nội bộ" */}
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={e.isInternal !== false}
                          disabled={disabled}
                          onChange={(event) => handleChangeProfileList(index, "isInternal", event.target.checked)}
                          color="primary"
                        />
                      }
                      label="Nội bộ"
                    />
                  </Grid>
                  {e.isInternal && (
                    <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 5 : 4}>
                      <Autocomplete
                        disableClearable
                        disabled={disabled}
                        options={props.profileList}
                        getOptionLabel={(option) => option.name}
                        value={props.profileList?.find((profile) => profile.id === e.profileId)}
                        onChange={(event, profile) =>
                          handleChangeProfileList(index, "profileId", parseInt(profile?.id))
                        }
                        renderInput={(params) => (
                          <TextField {...params} size="small" label="Thành viên" variant="outlined" />
                        )}
                      />
                    </Grid>
                  )}
                  {!e.isInternal && (
                    <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 5 : 4}>
                      <TextField
                        fullWidth
                        size="small"
                        disabled={disabled}
                        variant="outlined"
                        label="Tên thành viên"
                        value={e?.externalName || ""}
                        onChange={(event) => handleChangeProfileList(index, "externalName", event.target.value)}
                      />
                      {helperText && e.externalName === "" && (
                        <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                      )}
                    </Grid>
                  )}
                  {e.isInternal && (
                    <>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          disabled
                          label="Mã viên chức"
                          variant="outlined"
                          size="small"
                          value={props.profileList?.find((profile) => profile.id === e.profileId)?.code || ""}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          disabled
                          label="Đơn vị"
                          variant="outlined"
                          size="small"
                          value={
                            props.profileList?.find((profile) => profile.id === e.profileId)?.departmentProfile?.[0]
                              ?.department?.name || ""
                          }
                        />
                      </Grid>
                    </>
                  )}
                  <Grid item xs={values?.purposeId !== 1 && values?.purposeId !== 99999999 ? 3 : 2}>
                    <FormControl fullWidth disabled={disabled} variant="outlined" size="small">
                      <InputLabel style={{ padding: "0 8px", backgroundColor: "white" }}>Vai trò được giao</InputLabel>
                      <Select
                        native
                        fullWidth
                        value={e?.roleInOtherWork || "main"}
                        onChange={(event) => handleChangeProfileList(index, "roleInOtherWork", event.target.value)}
                      >
                        <option value="main">Chủ biên</option>
                        <option value="member">Thành viên</option>
                      </Select>
                    </FormControl>
                  </Grid>
                  {values?.purposeId === 1 && (
                    <Grid item xs={2}>
                      <FormControl required fullWidth error={!values?.profileIdForKpi}>
                        <Button
                          fullWidth
                          color="primary"
                          variant="outlined"
                          disabled={disabled}
                          style={{ height: 40 }}
                          startIcon={
                            typeof values?.profileIdForKpi === "number" && values?.profileIdForKpi === e.profileId ? (
                              <CheckBox />
                            ) : (
                              <CheckBoxOutlineBlank />
                            )
                          }
                          onClick={() => {
                            setDetail(null);
                            props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                            handleChangeForm(
                              "profileIdForKpi",
                              values?.profileIdForKpi !== e.profileId ? parseInt(e.profileId) : null,
                            );
                          }}
                        >
                          Tính KPI
                        </Button>
                        {!values?.profileIdForKpi && <FormHelperText>Phải chọn 1 người tính KPI</FormHelperText>}
                      </FormControl>
                    </Grid>
                  )}
                  {values?.purposeId === 99999999 && (
                    <Grid item xs={2}>
                      <FormControl required fullWidth error={!values?.profileIdForReward}>
                        <Button
                          fullWidth
                          disabled={disabled}
                          color="primary"
                          variant="outlined"
                          style={{ height: 40 }}
                          startIcon={
                            typeof values?.profileIdForReward === "number" &&
                            values?.profileIdForReward === e.profileId ? (
                              <CheckBox />
                            ) : (
                              <CheckBoxOutlineBlank />
                            )
                          }
                          onClick={() => {
                            setDetail(null);
                            handleChangeForm(
                              "profileIdForReward",
                              values?.profileIdForReward !== e.profileId ? parseInt(e.profileId) : null,
                            );
                          }}
                        >
                          Tính thưởng
                        </Button>
                        {!values?.profileIdForReward && <FormHelperText>Phải chọn 1 người tính thưởng</FormHelperText>}
                      </FormControl>
                    </Grid>
                  )}
                  <Grid item xs={2}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel id="statusInProject-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                        Trạng thái
                      </InputLabel>
                      <Select
                        native
                        fullWidth
                        disabled={disabled}
                        labelId="statusInProject-label"
                        value={e?.statusInProject || "K"}
                        onChange={(event) => handleChangeProfileList(index, "statusInProject", event.target.value)}
                      >
                        <option value="NCS">Đang làm NCS</option>
                        <option value="CH">Đang học Cao học</option>
                        <option value="K">Khác</option>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={1}>
                    <Button
                      fullWidth
                      disabled={disabled}
                      color="secondary"
                      variant="contained"
                      style={{ height: 40 }}
                      onClick={() => handleRemove(index)}
                    >
                      Xoá
                    </Button>
                  </Grid>
                </Grid>
              ))}
            </Grid>
            <Grid item xs={12}>
              <Button fullWidth disabled={disabled} variant="outlined" onClick={handleInsert}>
                Thêm thành viên
              </Button>
            </Grid>
          </Grid>
          {values?.profileIdForKpi !== null && values?.profileIdForKpi >= 0 && (
            <div style={{ marginTop: 16 }}>
              <EmploymentContractTable
                contract={detail}
                contractList={contractList}
                kpiIdForKpi={values?.kpiIdForKpi}
                contractIdForKpi={values?.contractIdForKpi}
                setDetail={setDetail}
                values={values}
                setValues={setValues}
                handleChangeForm={handleChangeForm}
              />
              <EmploymentContractDetailTable kpi={detail} />
            </div>
          )}
        </div>
        <div style={{ width: "40%", padding: "16px 24px", overflowY: "auto", backgroundColor: "#fafafa" }}>
          <Typography variant="h6" style={{ marginBottom: 16, fontWeight: 600 }}>
            Upload file minh chứng
          </Typography>
          <div
            style={{
              backgroundColor: "#ffebee",
              color: "#c62828",
              padding: "12px",
              marginBottom: 16,
              borderRadius: 4,
              whiteSpace: "pre-line",
            }}
          >
            {getNoteByType()}
          </div>
          <MultiFileManager
            fileUrls={fileUrls}
            setFileUrls={setFileUrls}
            newFiles={newFiles}
            setNewFiles={setNewFiles}
            disabled={false}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  history: select(state, "homeReducer", "history"),
  fileUrl: select(state, "fileReducer", "fileUrl"),
  profile: select(state, "profileReducer", "detail"),
  profileList: select(state, "profileReducer", "list"),
  isUploading: select(state, "fileReducer", "isFetching"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
  employmentContractDetail: select(state, "employmentContractReducer", "detail"),
  employmentContractListById: select(state, "employmentContractReducer", "listById"),
  timeResearchInformationList: select(state, "timeResearchInformationReducer", "list"),
});

const mapDispatchToProps = (dispatch) => ({
  updateOtherWork: (id, payload) => dispatch(updateOtherWork(id, payload)),
  acceptOtherWork: (id, accept) => dispatch(acceptOtherWork(id, accept)),
  requestRevisionOtherWork: (id, reason) => dispatch(requestRevisionOtherWork(id, reason)),
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  getTimeResearchInformationById: (id) => dispatch(getTimeResearchInformationById(id)),
  getAllEmploymentContractByProfileId: (id) => dispatch(getAllEmploymentContractByProfileId(id)),
  getTimeResearchInformation: (profileId, year) => dispatch(getTimeResearchInformation(profileId, year)),
  getEmploymentContractById: (id) => dispatch(getEmploymentContractById(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(OtherWorkUpdateModal));

